import React, { forwardRef } from "react";
import InputMask from "react-input-mask";
import { Input } from "antd";

const MaskedInput = forwardRef((props, ref) => {
  const {
    mask,
    maskChar,
    formatChars,
    alwaysShowMask,
    beforeMaskedStateChange,
    addonBefore,
    addonAfter,
    prefix,
    suffix,
    className,
    style,
    ...rest
  } = props;

  // If no mask → fallback to plain AntD Input
  if (!mask) {
    return (
      <Input
        ref={ref}
        addonBefore={addonBefore}
        addonAfter={addonAfter}
        prefix={prefix}
        suffix={suffix}
        className={className}
        style={style}
        {...rest}
      />
    );
  }

  // InputMask expects its child to be a controlled input component
  return (
    <InputMask
      mask={mask}
      maskChar={maskChar}
      formatChars={formatChars}
      alwaysShowMask={alwaysShowMask}
      beforeMaskedStateChange={beforeMaskedStateChange}
      {...rest}
    >
      {(inputProps) => (
        <Input
          {...inputProps}
          ref={ref}
          addonBefore={addonBefore}
          addonAfter={addonAfter}
          prefix={prefix}
          suffix={suffix}
          className={className}
          style={style}
        />
      )}
    </InputMask>
  );
});

MaskedInput.displayName = "MaskedInput";

export default MaskedInput;